/* eslint-disable */
export default {
  today: 'Hoy',
  yesterday: 'Ayer',
  empty: 'No hay registros de llamadas',
} as const;

// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"yesterday"@#@ @source: @#@"Yesterday"@#@
// @key: @#@"empty"@#@ @source: @#@"No call records"@#@
